@if (!showVideoUploading) {
  <div class="row g-0">
    <div class="col-md-6 p-4">
      <div class="ratio ratio-16x9">
        <div #videoWrapper class="column d-flex justify-content-center videoWrapper rounded">
          <video class="rounded w-100 h-100" style="transform: scaleX(-1);" #videoPlayer playsinline autoplay [muted]="testSpeakers || muteMic" disableRightClick></video>
          <div class="camera-container">
            @if (isRecording) {
              <div class="overlay-record"><i class="ri-record-circle-fill label-icon align-middle"></i></div>
            }
            @if (isRecording) {
              <div class="overlay-time">{{ time }}</div>
            }
            <audio #audioPlayer ></audio>
          </div>
        </div>
      </div>
      @if (!streamService.detect_face) {
        <p class="text-center pt-1 mb-0 text-danger">We can not detect your face</p>
      }
      @if (!streamService.light) {
        <p class="text-center pt-1 mb-0 text-danger">The lighting condition is not correct</p>
      }
      @if (streamService.detect_face && streamService.light) {
        <p class="text-center pt-1 mb-0 text-success">You are Good</p>
      }
    </div>
    <div class="col-md-6 p-4 pt-0">
      <div class="row mt-4">
        @if (!isRecording) {
          <div class="col-12">
            <button type="button" (click)="start()" class="btn btn-label btn-primary waves-effect waves-light" [disabled]="!allowStartRecording">
              <i class="ri-play-circle-line label-icon align-middle fs-16 me-2"></i>
              <span class="d-flex align-items-center">
                @if (loading) {
                  <span class="spinner-border flex-shrink-0" role="status">
                    <span class="visually-hidden"></span>
                  </span>
                }
                <span class="flex-grow-1" [ngClass]="loading ? 'ms-2' : ''">
                  Start
                </span>
              </span>
            </button>
          </div>
        }
        @if (isRecording) {
          <div class="col-12">
            <button type="button" (click)="stopRecording()" class="btn btn-label btn-danger waves-effect waves-light">
              <i class="ri-stop-circle-line label-icon align-middle fs-16 me-2"></i>
              <span class="d-flex align-items-center">
                @if (loading) {
                  <span class="spinner-border flex-shrink-0" role="status">
                    <span class="visually-hidden"></span>
                  </span>
                }
                <span class="flex-grow-1" [ngClass]="loading ? 'ms-2' : ''">
                  Stop Recording
                </span>
              </span>
            </button>
          </div>
        }
      </div>
      <div class="row mt-4 text-center justify-content-between">
        <div class="col-4">
          <button type="button" (click)="markTime('v_start')" [ngClass]="!isMarked('v_start') ? 'btn-warning' : 'btn-success'" class="btn btn-label waves-effect waves-light" [disabled]="isMarked('v_start') || !isRecording">
            <i [ngClass]="!isMarked('v_start') ? 'ri-error-warning-line' : 'ri-checkbox-circle-line'" class="label-icon align-middle fs-16 me-2"></i>
            <span class="d-flex align-items-center">
              @if (loading) {
                <span class="spinner-border flex-shrink-0" role="status">
                  <span class="visually-hidden"></span>
                </span>
              }
              <span class="flex-grow-1" [ngClass]="loading ? 'ms-2' : ''">
                Mark start voice sample
              </span>
            </span>
          </button>
        </div>
        <div class="col-4">
          <button type="button" (click)="markTime('v_end')" [ngClass]="!isMarked('v_end') ? 'btn-warning' : 'btn-success'" class="btn btn-label waves-effect waves-light" [disabled]="isMarked('v_end') || !isRecording">
            <i [ngClass]="!isMarked('v_end') ? 'ri-error-warning-line' : 'ri-checkbox-circle-line'" class="label-icon align-middle fs-16 me-2"></i>
            <span class="d-flex align-items-center">
              @if (loading) {
                <span class="spinner-border flex-shrink-0" role="status">
                  <span class="visually-hidden"></span>
                </span>
              }
              <span class="flex-grow-1" [ngClass]="loading ? 'ms-2' : ''">
                Mark end voice sample
              </span>
            </span>
          </button>
        </div>
        <div class="col-4">
          <button type="button" (click)="markTime('reset_v')" class="btn btn-danger waves-effect waves-light" [disabled]="!isRecording">
            Reset voice sample
          </button>
        </div>
      </div>
      @if (!isRecording) {
        <div class="row mt-5">
          <div class="col-12">
            <div class="mb-3">
              <label for="speaker" class="form-label">Number of speakers <span class="text-danger">*</span></label>
              <ng-select id="speaker" [items]="speakers" bindLabel="name" bindValue="value" [searchable]="true" name="speakers" [(ngModel)]="speakerSelected" [ngModelOptions]="{standalone: true}" placeholder="Choose number of speakers" required></ng-select>
              <div class="invalid-feedback" [ngClass]="submitted && !speakerSelected ? 'd-block' : ''">Please select the number of speakers.</div>
            </div>
            <div>
              <label for="camera" class="font-weight-light mt-3">Camera</label>
              <ng-select
                [items]="videoDevices"
                [bindLabel]="'label'"
                [bindValue]="'deviceId'"
                [clearable]="false"
                [searchable]="false"
                [(ngModel)]="selectedCamera"
                placeholder=" "
                class="w-100"
                (change)="startVideoStream()">
              </ng-select>
            </div>
            <div class="mt-3">
              <label for="speakers" class="font-weight-light">Speakers</label>
              <div class="input-group flex-nowrap">
                <ng-select
                  [items]="audioOutputDevices"
                  [bindLabel]="'label'"
                  [bindValue]="'deviceId'"
                  [clearable]="false"
                  [searchable]="false"
                  [(ngModel)]="selectedSpeaker"
                  placeholder=""
                  class="w-100">
                </ng-select>
                <label class="input-group-text p-0 border-0" for="sound">
                  <button
                    type="button"
                    style="background: #5b7ffc;"
                    class="btn btn-info waves-effect waves-light"
                    (click)="playsound()"
                    title="Test Speaker">
                    <i class="ri-volume-up-line align-bottom"></i>
                  </button>
                </label>
              </div>
            </div>
            <div class="mt-3">
              <label for="mic" class="font-weight-light">Microphone</label>
              <div class="input-group flex-nowrap">
                <ng-select
                  [items]="audioInputDevices"
                  [bindLabel]="'label'"
                  [bindValue]="'deviceId'"
                  [clearable]="false"
                  [searchable]="false"
                  [(ngModel)]="selectedMicrophone"
                  placeholder=""
                  class="w-100"
                  (change)="startMicrophoneStream()">
                </ng-select>
                <label class="input-group-text p-0 border-0" for="mute">
                  <button
                    type="button"
                    style="background: #5b7ffc;"
                    class="btn btn-info waves-effect waves-light"
                    (click)="muteStatusChange()"
                    title="Test Speaker">
                    <i class="align-bottom" [ngClass]="muteMic ? 'ri-mic-off-line' : 'ri-mic-line'"></i>
                  </button>
                </label>
              </div>
            </div>
            <div class="pids-wrapper w-100 mt-3 d-flex">
              <div class="pid rounded m-2"></div>
              <div class="pid rounded m-2"></div>
              <div class="pid rounded m-2"></div>
              <div class="pid rounded m-2"></div>
              <div class="pid rounded m-2"></div>
              <div class="pid rounded m-2"></div>
              <div class="pid rounded m-2"></div>
              <div class="pid rounded m-2"></div>
              <div class="pid rounded m-2"></div>
              <div class="pid rounded m-2"></div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}

@if (showVideoUploading) {
  <div class="justify-content-center align-items-center mt-3 mb-3">
    <div class="row text-center">
      @if (uploadInProgress) {
        <h5 class="text-info">Please wait while your video is being uploaded... <strong>{{ 'ASSESSMENTAPP.CLOSE_WINDOW' | translate }}</strong></h5>
      }
    </div>
    @if (uploadInProgress) {
      <div class="row text-center">
        <circle-progress class="flex"
          [percent]="progressValue"
          [radius]="100"
          [outerStrokeWidth]="6"
          [showInnerStroke]="false"
          [outerStrokeColor]="'#5b7ffc'"
          [animation]="false"
          [showSubtitle]=false
          [titleColor]="'#5b7ffc'"
          [backgroundPadding] = 20
          [unitsColor]="'#5b7ffc'">
        </circle-progress>
      </div>
    }
    @if (!uploadInProgress) {
      <div class="row text-center">
        <h5 class="text-info" class="flex">{{ 'ASSESSMENTAPP.UPLOADED' | translate }}</h5>
      </div>
    }
  </div>
}

<ng-template #startRecordingModal let-modal>
  <div class="modal-header">
    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <h3>Guidelines for Baseline</h3>
    <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>
    <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>
    <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Close</button>
    <button type="button" class="btn" [ngClass]="speakerSelected === 'n' ? 'btn-warning' : 'btn-primary'" (click)="continue()">{{ speakerSelected === 'n' ? 'Continue' : 'Start Recording'}}</button>
  </div>
</ng-template>

<ng-template #voiceBaseModal let-modal>
  <div class="modal-header">
    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <h3>Guidelines for voice sample</h3>
    <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>
    <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>
    <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor fringilla.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Close</button>
    <button type="button" class="btn btn-primary" (click)="startRecording()">Start Recording</button>
  </div>
</ng-template>